import request from '@/utils/edp/request.js'
// 获取友情链接
export const apiLinks = () =>
  request({
    method: 'get',
    url: '/api/links'
  })
